module.exports = function() {
  return new Worker(__webpack_public_path__ + "62ca35ef28591c38747b.worker.js");
};